import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Flex } from "@radix-ui/themes";
import {
  DragHandleDots1Icon,
  DragHandleDots2Icon,
} from "@radix-ui/react-icons";
import { Button } from "@/components/ui/button";
import { TrashIcon } from "@radix-ui/react-icons";

export function SortableItem(props: {
  id: string;
  children: React.ReactNode;
  onDelete: () => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "default",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={
        "flex gap-2 p-2 items-center shadow-sm border border-gray-200 rounded-md  bg-white justify-between"
      }
    >
      <Flex gap={"2"} align={"center"}>
        <Flex {...listeners} style={{ cursor: "move" }}>
          <DragHandleDots2Icon />
        </Flex>
        {props.children}
      </Flex>
      <Button
        variant={"ghost"}
        color="gray"
        size={"icon"}
        onClick={props.onDelete}
      >
        <TrashIcon />
      </Button>
    </div>
  );
}
